var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6873 7.26894L8.01855 0.293945L12.3498 7.26894H3.6873ZM12.3311 15.7064C11.3811 15.7064 10.5811 15.3814 9.93105 14.7314C9.28105 14.0814 8.95605 13.2814 8.95605 12.3314C8.95605 11.3814 9.27793 10.5814 9.92168 9.93145C10.5654 9.28144 11.3686 8.95644 12.3311 8.95644C13.2811 8.95644 14.0811 9.28144 14.7311 9.93145C15.3811 10.5814 15.7061 11.3814 15.7061 12.3314C15.7061 13.2814 15.3811 14.0814 14.7311 14.7314C14.0811 15.3814 13.2811 15.7064 12.3311 15.7064ZM0.987305 15.2377V9.31269H6.9123V15.2377H0.987305ZM12.3311 14.4314C12.9186 14.4314 13.4154 14.2283 13.8217 13.8221C14.2279 13.4158 14.4311 12.9189 14.4311 12.3314C14.4311 11.7439 14.2279 11.2471 13.8217 10.8408C13.4154 10.4346 12.9186 10.2314 12.3311 10.2314C11.7436 10.2314 11.2467 10.4346 10.8404 10.8408C10.4342 11.2471 10.2311 11.7439 10.2311 12.3314C10.2311 12.9189 10.4342 13.4158 10.8404 13.8221C11.2467 14.2283 11.7436 14.4314 12.3311 14.4314ZM2.2623 13.9627H5.6373V10.5877H2.2623V13.9627ZM5.99355 5.9752H10.0436L8.01855 2.7127L5.99355 5.9752Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.5aa97f76.svg";
export { ForwardRef as ReactComponent };